/** The sticky session banner (`.bandeau`) shown on the guidance and building screens. */
import { t } from '../../../i18n/fr';

import type { SessionProgress } from '../types';

export interface SessionBannerProps {
  name: string;
  /** Active participants, shown as a rough headcount of binômes. */
  participantsCount: number;
  progress: SessionProgress;
  /** Tapping the banner goes back to the "rejoindre" screen. */
  onClick?: () => void;
}

/**
 * Render the session banner: name, headcount and door progress.
 *
 * @param props - Session name, participant count and progress.
 * @returns The banner element.
 */
export function SessionBanner({ name, participantsCount, progress, onClick }: SessionBannerProps) {
  const total = progress.recorded + progress.pending + progress.candidates_left;
  const binomesLabel =
    participantsCount === 1
      ? t('session.card.binome')
      : t('session.card.binomes', { count: participantsCount });

  return (
    <button type="button" className="bandeau" onClick={onClick} disabled={!onClick}>
      <span>{name}</span>
      <span className="pastille">{binomesLabel}</span>
      <span style={{ opacity: 0.8 }}>
        {t('session.card.doorsProgress', { recorded: progress.recorded, total })}
      </span>
    </button>
  );
}
